import { useState } from 'react';
import { SetType } from '@/stores/store.types';
import { Pill } from '@/components/Pill';
import { DeleteModal } from './DeleteModal';
import { IconName } from '@/components/NeolexonIcon/Icons/types';
import { SetCardMenu } from './SetCardMenu';
import { CardTemplate } from '@/components/CardTemplate';
import { NeolexonIcon } from '@/components/NeolexonIcon';
import colors from '@/config/colors';
import { useSetsMode } from '@/contexts/SetsModeContext/useSetsMode';
import { View } from 'react-native';
import { styles } from './styles';

const iconMap = {
  Wörtersets: 'letter',
  Sätzesets: 'sentence',
  Textesets: 'reading',
};

const singularMap = {
  Wörtersets: 'Wörterset',
  Sätzesets: 'Sätzeset',
  Textesets: 'Texteset',
};

type SetCardProps = {
  data: any;
  type: SetType;
  patientID: string;
  fetchPatientsWrapper: () => void;
  selectedPatientFullName: string;
  refreshPatient: () => void;
};

export const SetCard = ({
  data,
  type,
  patientID,
  fetchPatientsWrapper,
  selectedPatientFullName,
  refreshPatient,
}: SetCardProps) => {
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    isSetActive: false,
  });
  const { mode } = useSetsMode();
  const { name, _id, appDisplayName } = data ?? {};

  return (
    <>
      <DeleteModal
        data={data}
        deleteModal={deleteModal}
        fetchPatientsWrapper={fetchPatientsWrapper}
        patientID={patientID}
        refreshPatient={refreshPatient}
        selectedPatientFullName={selectedPatientFullName}
        setDeleteModal={setDeleteModal}
        type={type}
      />
      <CardTemplate
        headerBackground={
          mode === 'bildkarten'
            ? () => (
                <View style={styles.headerBackground} pointerEvents="none">
                  <NeolexonIcon
                    name="flowersCard"
                    size={118}
                    color={colors.newUI.therapist.primaryBlue10}
                  />
                </View>
              )
            : undefined
        }
        footerSection={() => (
          <SetCardMenu
            appDisplayName={appDisplayName}
            exerciseSetName={name}
            id={_id}
            patientID={patientID}
            setDeleteModal={setDeleteModal}
            type={type}
          />
        )}
        name={name}
        pillsSection={() => (
          <Pill
            label={singularMap[type]}
            icon={iconMap[type] as IconName}
            isNeolexon={false}
            iconSize={22}
          />
        )}
      />
    </>
  );
};
